import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  BooleanField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import dayjs from "../../dayjsConfig";
import { IEvent } from "interfaces";

const formatUtcWallClock = (val: any) =>
  val ? dayjs.utc(val).format("YYYY-MM-DD HH:mm:ss") : "-";

export const EventList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<IEvent>({
    initialSorter: [
      {
        field: "created_at",
        order: "desc",
      },
    ],
  });

  return (
      <List>
        <Table {...tableProps} rowKey="event_id">
          <Table.Column
              dataIndex="event_id"
              key="event_id"
              title="ID"
              render={(value) => <TextField value={value} />}
          />
          <Table.Column
              dataIndex="name"
              key="name"
              title={t("event.fields.name")}
              render={(value) => <TextField value={value} />}
          />
          <Table.Column
              dataIndex="lifecycle_status"
              key="lifecycle_status"
              title={t("event.fields.lifecycle_status")}
              render={(value) => (
                <TextField value={value ? t(`event.lifecycle_status.${value}`) : "-"} />
              )}
              defaultSortOrder={getDefaultSortOrder("lifecycle_status", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="type"
              key="type"
              title={t("event.fields.type")}
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("type", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="is_thematic"
              key="is_thematic"
              title={t("event.fields.is_thematic")}
              render={(value) => <BooleanField value={!!value} />}
              defaultSortOrder={getDefaultSortOrder("is_thematic", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="max_players"
              key="max_players"
              title={t("event.fields.max_players")}
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("max_players", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="featured"
              key="featured"
              title={t("event.fields.featured")}
              render={(value) => <BooleanField value={value} />}
              defaultSortOrder={getDefaultSortOrder("featured", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="start_datetime"
              key="start_datetime"
              title={t("event.fields.start_datetime")}
              render={(value) => <TextField value={formatUtcWallClock(value)} />}
              defaultSortOrder={getDefaultSortOrder("start_datetime", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="end_datetime"
              key="end_datetime"
              title={t("event.fields.end_datetime")}
              render={(value) => <TextField value={formatUtcWallClock(value)} />}
              defaultSortOrder={getDefaultSortOrder("end_datetime", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="min_app_version"
              key="min_app_version"
              title={t("event.fields.min_app_version")}
              render={(value) => <TextField value={value || "-"} />}
          />
          <Table.Column
              dataIndex="status"
              key="status"
              title={t("event.fields.status")}
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("status", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="player_count"
              key="player_count"
              title={t("event.fields.player_count")}
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("player_count", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="group_count"
              key="group_count"
              title={t("event.fields.group_count")}
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("group_count", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="show_from"
              key="show_from"
              title={t("event.fields.show_from")}
              render={(value) => <TextField value={formatUtcWallClock(value)} />}
              defaultSortOrder={getDefaultSortOrder("show_from", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="show_until"
              key="show_until"
              title={t("event.fields.show_until")}
              render={(value) => <TextField value={formatUtcWallClock(value)} />}
              defaultSortOrder={getDefaultSortOrder("show_until", sorter)}
              sorter
          />
          <Table.Column
              dataIndex="created_at"
              key="created_at"
              title={t("parameter.fields.created_at")}
              render={(value) => <DateField value={value} format="LLL" />}
              defaultSortOrder={getDefaultSortOrder("created_at", sorter)}
              sorter
          />
          <Table.Column<IEvent>
              title={t("table.actions")}
              dataIndex="actions"
              render={(_, record) => (
                  <Space>
                    <EditButton hideText size="small" recordItemId={record.event_id} />
                    <ShowButton hideText size="small" recordItemId={record.event_id} />
                    <DeleteButton hideText size="small" recordItemId={record.event_id} />
                  </Space>
              )}
          />
        </Table>
      </List>
  );
};